<template>
  <div class="container-fluid py-3 px-5">
    <!-- Header -->
    <div class="text-center mb-4">
      <h1 class="title-page mb-1">Team Recognition</h1>
      <p class="sub-title">
        Celebrating Our Stars <span class="text-danger">★</span>
      </p>
    </div>

    <!-- HERO CARD -->
    <div class="row mb-4">
      <div class="col-12">
        <div
          class="card hero-card border-0 shadow-sm p-4 d-flex flex-row align-items-center position-relative overflow-hidden"
        >
          <div class="bg-icon-decoration">
            <i data-feather="sun"></i>
          </div>

          <div class="position-relative mr-4 hero-avatar">
            <img
              :src="hero.avatar ? hero.avatar : 'https://api.dicebear.com/7.x/avataaars/svg?seed=Chun'"
              class="rounded-circle border border-white shadow-sm"
              width="100"
              height="100"
              alt="Avatar"
            />
            <span
              class="badge badge-pill badge-primary bird-badge position-absolute"
            >
              <i data-feather="award"></i>
            </span>
          </div>

          <div class="hero-text">
            <p
              class=" font-weight-bold text-uppercase letter-spacing"
            >
              Early Bird of the Day
            </p>
            <h2 class="display-4 font-weight-bold brand-red-text mb-0">
              {{ hero.name }}
            </h2>
            <p class="h5 text-secondary mt-1">
              Arrived at {{ hero.time }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- STAT CARDS -->
    <div class="row">
      <div
        v-for="(card, index) in statCards"
        :key="index"
        class="col-md-4 mb-3"
      >
        <div
          class="card stat-card h-100 p-4 shadow-sm text-center border-0"
        >
          <i
            :data-feather="card.icon"
            class="stat-icon mb-3"
          ></i>

          <p class="lable text-uppercase letter-spacing mb-2 d-block">
            {{ card.label }}
          </p>

          <h3 class=" font-weight-bold mb-2 mt-2">
            {{ card.title }}
          </h3>

          <p class="lable mb-0">
            {{ card.sub }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import feather from 'feather-icons'
import {axiosGet} from "../../../common/Helper/AxiosHelper";
import {PUBLIC_DASHBOARD} from "../../../tenant/Config/ApiUrl";
import CoreLibrary from "../../../core/helpers/CoreLibrary";
export default {
  name: 'TeamRecognition',
  extends: CoreLibrary,
  data() {
    return {
      hero: {
        name: 'Chun Phallamonunhh',
        time: '7:42 AM',
        avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Chun',
      },

      statCards: [
        {
          icon: 'award',
          label: 'Early Bird of Month',
          title: 'Ratanak S.',
          sub: 'Avg: 8:02 AM',
        },
        {
          icon: 'users',
          label: 'Perfect Attendance',
          title: '8 People',
          sub: 'This Month',
        },
        {
          icon: 'target',
          label: 'Most Improved',
          title: 'Bopha L.',
          sub: '-18 min avg',
        },
      ],
      timerInterval: null,
    }
  },
  methods: {
    getData() {
      axiosGet(`${PUBLIC_DASHBOARD}/team-recognition`).then(({data}) => {
        this.statCards = [
          {
            icon: 'award',
            label: 'Early Bird of Month',
            title: data.month_star.name,
            sub: `Avg: ${data.month_star.avg_time}`,
          },
          {
            icon: 'users',
            label: 'Perfect Attendance',
            title: data.perfect_attendance,
            sub: 'This Month',
          },
          {
            icon: 'clock',
            label: 'Longest Stay',
            title: data.longer_stay.name,
            // total minutes stay
            sub: data.longer_stay.total_duration + ' min ',
          },
        ];
        this.hero = {
          name: data.day_star.name,
          time: data.day_star.time,
          avatar: data.day_star.avatar,
        };
      });
    }
  },
  created() {
    this.getData();
  },
  mounted() {
    feather.replace();
    this.timerInterval = setInterval(this.getData, 60 * 1000); // Update every minute
  },
  beforeDestroy() {
    clearInterval(this.timerInterval); // Clear the interval when the component is unmounted
  },

  updated() {
    feather.replace()
  },
}
</script>

<style scoped>
/* ================= BASE ================= */
.container-fluid {
  overflow: hidden;
}

.title-page {
    font-size: 1.6rem; 
    line-height: 1; 
    font-weight: 1000; /* font-bold */
    color: rgb(17, 24, 39); /* text-gray-900 */
    letter-spacing: -0.025em; /* tracking-tight */
} 
.sub-title {
    font-size: 1rem; /* text-2xl (24px) */
    line-height: 2rem; 
    color: rgb(107, 114, 128); /* text-gray-500 */
}
.section-title {
    font-size: 1.875rem;                                                                                                                                
    line-height: 2.25rem; 
    font-weight: 700; 
}

.brand-red-text {
  color: #b91c1c;
}

.hero-card {
  background-color: #f9e2e6;
  border-radius: 1rem;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px,
              rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
}

.stat-card {
  border-radius: 1rem;
  transition: all 0.3s ease;
  cursor: pointer;
  align-items: center;
}

.display-4   {
  font-size:1.8rem;
}

.stat-icon {
  width: 50px;
  height: 50px;
  color:#a32a31;
  transition: color 0.3s ease;
  cursor: pointer;
}
.font-weight-bold h3 {
  font-size:1.5rem;
}

/* Hover */
.stat-card:hover {
  background-color: #a32a31;
  color: white;
  transform: translateY(-8px);
}

.stat-card:hover h3,
.stat-card:hover p,
.stat-card:hover small {
  color: white !important;
}

.stat-card:hover .stat-icon {
  color: white;
}

/* Decoration */
.bg-icon-decoration {
  position: absolute;
  right: 20px;
  font-size: 8rem;
  color: #b91c1c;
  opacity: 0.05;
  transform: rotate(-15deg);
}

/* Badge */
.bird-badge {
  top: -5px;
  right: -5px;
  background-color: #b91c1c;
  padding: 6px;
  border: 2px solid white;
}

/* Typography */
.letter-spacing {
  letter-spacing: 0.05rem;
  font-size: 1rem;
}

/* ================= RESPONSIVE ================= */

/* ≤1200px */
@media (max-width: 1200px) {
  .container-fluid {
    padding-left: 30px;
    padding-right: 30px;
  }
}

/* ≤992px (Tablet) */
@media (max-width: 992px) {
  .hero-card {
    flex-direction: column;
    text-align: center;
  }

  .hero-avatar {
    margin-right: 0 !important;
    margin-bottom: 15px;
  }

  .bg-icon-decoration {
    display: none;
  }

  .display-4 {
    font-size: 1.2rem;
  }
}

/* ≤768px */
@media (max-width: 768px) {
  .container-fluid {
    padding-left: 20px;
    padding-right: 20px;
  }

  .stat-card {
    padding: 24px;
  }

  .display-4 {
    font-size: 1rem;
  }
  .lable {
    font-size : 0.8rem;
  }
}

/* ≤576px (Mobile) */
@media (max-width: 576px) {
  .container-fluid {
    padding-left: 1rem !important;
    padding-right: 15px !important;    
  }


  .hero-card img {
    width: 80px;
    height: 80px;
  }

  .display-4{
    font-size:1rem;
  }
  .lable {
    font-size: 0.8rem;
  }

  .stat-icon {
    width: 28px;
    height: 28px;
  }
}
</style>
